import call from "./call";
import { UsageQueryParams, UsageRow } from "../Models/usage";

export const getUsage = async (
  params: UsageQueryParams,
): Promise<UsageRow[]> => {
  const response = await call.get("/v1/admin/usage/", {
    params,
    snack: {
      error: "usage.fetchError",
    },
  });
  return response.data;
};
